





















import { Component, Prop, Vue } from "vue-property-decorator";
import CreatePartyForm from "./CreatePartyForm.vue";
import { Party } from "@/types";
import { checkStreamPage } from "@/router";

@Component({
  components: {
    CreatePartyForm
  }
})
export default class CreatePartyPage extends Vue {
  @Prop({ required: false }) party?: Party;

  editableParty: Party = {
    jitsiServerUrl: "https://meet.jit.si",
    jitsiRoomName: "",
    streamUrl: ""
  };

  mounted(): void {
    if (this.party) {
      this.editableParty = this.party
    }
  }

  onSubmit(party: Party): void {
    this.$router.push(checkStreamPage(party));
  }
}
